import React from 'react';
import ReactDOM from 'react-dom/client';
import {App} from './App';

const roots = document.querySelectorAll('.react-root');

roots.forEach((item) => {
  const root = ReactDOM.createRoot(item);
  root.render(<App part={item.getAttribute('data-react-id')} />);
});